import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import { mathEquationLogic } from './math_equation.logic';
import { MathEquationActivityView } from './MathEquationViews';

export const mathEquationPlugin: ActivityPlugin<'math_equation'> = {
  ...mathEquationLogic,
  displayName: GAME_MODE_CATALOG.math_equation.displayName,
  icon: GAME_MODE_CATALOG.math_equation.icon,
  HostView: MathEquationActivityView,
  StudentView: MathEquationActivityView,
  ProjectorView: MathEquationActivityView,
};

export { demoMathEquationPayload } from './math_equation.logic';
